"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PreloadImage = _interopRequireDefault(require("../PreloadImage"));
var _PreloadIframe = _interopRequireDefault(require("../PreloadIframe"));
var _Button = _interopRequireDefault(require("../Button"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MobileGalleryVideo = /*#__PURE__*/function (_React$PureComponent) {
  function MobileGalleryVideo(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, MobileGalleryVideo);
    _this = _callSuper(this, MobileGalleryVideo, [props]);
    _this.state = {
      opened: false,
      isClient: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(MobileGalleryVideo, _React$PureComponent);
  return (0, _createClass2["default"])(MobileGalleryVideo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isClient: true
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        opened: true
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        opened: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        opened = _this$state.opened,
        isClient = _this$state.isClient;
      var _this$props = this.props,
        _this$props$data = _this$props.data,
        thumbImage = _this$props$data.images.thumbImage,
        content = _this$props$data.special.content,
        height = _this$props.height,
        landscape = _this$props.landscape;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
        height: height
      }, opened ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledClose, {
        onClick: this.handleClose
      }, "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C"), /*#__PURE__*/_react["default"].createElement(StyledIframe, {
        src: content,
        height: height
      })) : /*#__PURE__*/_react["default"].createElement(StyledTriangleWrapper, {
        cover: !landscape,
        functional: true,
        isClient: isClient,
        onClick: this.handleClick,
        src: thumbImage
      }, /*#__PURE__*/_react["default"].createElement(StyledTriangle, null)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.disabled) {
        return {
          opened: false
        };
      }
      return null;
    }
  }]);
}(_react["default"].PureComponent);
MobileGalleryVideo.propTypes = {
  data: _propTypes["default"].shape({
    images: _propTypes["default"].shape({
      smallImage: _propTypes["default"].string,
      fullImage: _propTypes["default"].string,
      thumbImage: _propTypes["default"].string.isRequired,
      thumbImageX2: _propTypes["default"].string
    }).isRequired,
    special: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      content: _propTypes["default"].string,
      title: _propTypes["default"].string
    }).isRequired
  }).isRequired,
  height: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  landscape: _propTypes["default"].bool
};
MobileGalleryVideo.defaultProps = {
  height: 210,
  disabled: false,
  landscape: false
};
var StyledTriangleWrapper = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MobileGalleryVideo__StyledTriangleWrapper",
  componentId: "sc-1n5htr4-0"
})(["position:absolute;width:100%;height:100%;z-index:2;display:flex;justify-content:center;align-items:center;cursor:pointer;background-repeat:no-repeat;background-size:cover;background-position:center;background-image:url(\"", "\");"], function (_ref) {
  var src = _ref.src;
  return src;
});
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "MobileGalleryVideo__StyledContainer",
  componentId: "sc-1n5htr4-1"
})(["height:", "px;"], function (props) {
  return props.height;
});
var StyledTriangle = _styledComponents["default"].div.withConfig({
  displayName: "MobileGalleryVideo__StyledTriangle",
  componentId: "sc-1n5htr4-2"
})(["width:0;height:0;border-style:solid;border-width:31px 0 31px 38px;border-color:transparent transparent transparent #ffffff;"]);
var StyledIframe = (0, _styledComponents["default"])(_PreloadIframe["default"]).withConfig({
  displayName: "MobileGalleryVideo__StyledIframe",
  componentId: "sc-1n5htr4-3"
})(["iframe{display:block;width:100% !important;height:", "px;margin:0 !important;}"], function (props) {
  return props.height;
});
var StyledImage = (0, _styledComponents["default"])(_PreloadImage["default"]).withConfig({
  displayName: "MobileGalleryVideo__StyledImage",
  componentId: "sc-1n5htr4-4"
})(["", "{background-size:", ";}"], _PreloadImage["default"].Image, function (props) {
  return props.cover ? 'cover' : 'auto 100%';
});
var StyledClose = (0, _styledComponents["default"])(_Button["default"]).attrs({
  size: 'tiny'
}).withConfig({
  displayName: "MobileGalleryVideo__StyledClose",
  componentId: "sc-1n5htr4-5"
})(["position:absolute;top:10px;right:10px;z-index:10;background:", ";"], function (props) {
  return props.theme.colors.white;
});
MobileGalleryVideo.Iframe = StyledIframe;
MobileGalleryVideo.Image = StyledImage;
MobileGalleryVideo.Closer = StyledClose;
var _default = exports["default"] = MobileGalleryVideo;